import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { ScrollButton } from './ui/Button';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function HeroSection() {
  const painPoints = ['Si para llenar la agenda tienes que publicar descuentos constantemente', 'Si tus clientes comparan tu precio con el spa más barato de la ciudad', 'Si Groupon o los cupones te traen clientes que no regresan sin otra oferta', 'Si tienes tratamientos de alto valor (Botox, microblading, laser) pero no sabes cómo atraer a quienes los pueden pagar', 'Si tu Instagram tiene seguidores pero no se convierten en citas'];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center py-20 md:py-28 px-4 overflow-hidden bg-carbon" data-id="element-177">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/4 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-178" />

      <div className="max-w-7xl mx-auto w-full relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-179">
        {/* Mobile Image (shows on top for mobile, hidden on lg) */}
        <motion.div className="lg:hidden w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden relative shadow-2xl border border-border" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} data-id="element-180">
          <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/40 to-transparent z-10" data-id="element-181" />
          <img src="https://cdn.magicpatterns.com/uploads/diJSsntoh9G4pBJKPbFwGq/heylloyd-image-1773432961826.png" alt="Spa Professional" className="w-full h-full object-cover object-center" data-id="element-182" />
        </motion.div>

        {/* Content */}
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col" data-id="element-183">
          <motion.div variants={itemVariants} className="mb-8" data-id="element-184">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gold mb-6 leading-tight tracking-tight" data-id="element-185">
              ¿Regalando servicios de $200 por $80 solo para tener la agenda
              ocupada?
            </h1>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed" data-id="element-186">
              En 90 días o menos, llenamos tu spa con clientes premium que pagan
              el precio completo — sin cupones, sin descuentos, sin rogar por
              citas. Clientes que regresan cada mes y te refieren a sus amigas.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-surface border border-border rounded-2xl p-6 md:p-8 mb-10 shadow-xl" data-id="element-187">
            <ul className="space-y-5" data-id="element-188">
              {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-189">
                  <AlertCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" aria-hidden="true" data-id="element-190" />
                  <span className="text-neutral-300 text-base leading-relaxed" data-id="element-191">
                    {point}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-start gap-4" data-id="element-192">
            <ScrollButton onClick={scrollToContact} className="w-full sm:w-auto text-sm md:text-base" data-id="element-193">
              QUIERO CLIENTES DE ALTO TICKET
            </ScrollButton>
            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-gold transition-colors flex items-center gap-2 text-sm font-medium ml-2" data-id="element-194">
              O agenda directamente <ArrowRight className="w-4 h-4" data-id="element-195" />
            </a>
          </motion.div>
        </motion.div>

        {/* Desktop Image (hidden on mobile, shows on lg) */}
        <motion.div className="hidden lg:block w-full h-[700px] rounded-3xl overflow-hidden relative shadow-2xl border border-border" initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-196">
          <div className="absolute inset-0 bg-gradient-to-tr from-carbon/60 via-transparent to-transparent z-10" data-id="element-197" />
          <img src="https://cdn.magicpatterns.com/uploads/diJSsntoh9G4pBJKPbFwGq/heylloyd-image-1773432961826.png" alt="Spa Professional" className="w-full h-full object-cover object-center" data-id="element-198" />
        </motion.div>
      </div>
    </section>;
}